import { useState, useRef } from "react";

export function useDragReorder() {
  const [list, setList] = useState([]);
  const [original, setOriginal] = useState([]);
  const [orderChanged, setOrderChanged] = useState(false);

  const dragIndexRef = useRef(null);

  //Initialize list from parent
  const initialize = (items) => {
    setList(items);
    setOriginal(JSON.parse(JSON.stringify(items)));
    setOrderChanged(false);
  };

  //Drag start
  const onDragStart = (e, index) => {
    dragIndexRef.current = index;
    e.dataTransfer.effectAllowed = "move";
    try {
      e.dataTransfer.setData("text/plain", index.toString());
    } catch {}
  };

  //Drag over
  const onDragOver = (e) => e.preventDefault();

  //Drop
  const onDrop = (e, dropIndex) => {
    e.preventDefault();

    const fromIndex =
      dragIndexRef.current ?? Number(e.dataTransfer.getData("text/plain"));

    if (fromIndex === dropIndex) return;

    const cloned = [...list];
    const [moved] = cloned.splice(fromIndex, 1);
    cloned.splice(dropIndex, 0, moved);

    const updated = cloned.map((item, i) => ({
      ...item,
      sequence: i + 1,
    }));

    setList(updated);

    // Compare using ID or unique field
    const changed = updated.some((u) => {
      const orig = original.find((o) => o._id === u._id);
      return orig && orig.sequence !== u.sequence;
    });

    setOrderChanged(changed);
  };

  //Cancel reorder
  const cancelOrder = () => {
    setList(JSON.parse(JSON.stringify(original)));
    setOrderChanged(false);
  };

  //Save reorder
  const saveOrder = async (saveFn) => {
    await saveFn(list);
    setOriginal(JSON.parse(JSON.stringify(list)));
    setOrderChanged(false);
  };

  return {
    list,
    original,
    orderChanged,
    initialize,
    onDragStart,
    onDragOver,
    onDrop,
    cancelOrder,
    saveOrder,
    setList,
  };
}
